import React, { useState } from 'react';

import { colors } from 'spw-theme';
import {
  AlignStartColumn,
  JustifyStartRow,
} from 'spw-shared/globalComponents/grid';
import { FullWidthRow } from 'spw-components/floorplan/styles';
import {
  SPWCancelButton,
  SPWSaveButton,
} from 'spw-shared/globalComponents/buttons';
import { Radio, Grid } from '@mui/material';
import {
  IProjectSettings,
  RatioCalculationType,
} from 'spw-redux/modules/settings/types';
import { numberWithCommas } from 'spw-shared/utils';

import {
  DialogNoteBody,
  ScenarioNameDialogTitle,
  WorksheetUpdateDialogContent,
  FormControlLabel,
} from './styles';
import {
  FileCabinetsLockersRatioDialog,
  InputLabel,
} from './total-program/styles';

export const ProgramFileCabinetsLockersRatioModal = ({
  projectSettings: propProjectSettings,
  setProjectSettings,
  open,
  onClose,
  headcount,
  workSeats,
  headcountWithVacancy,
  headcountWithUtilization,
}: {
  projectSettings: IProjectSettings;
  setProjectSettings: (projectSettings: IProjectSettings) => void;
  open: boolean;
  onClose: () => void;
  headcount: number;
  workSeats: number;
  headcountWithVacancy: number;
  headcountWithUtilization: number;
}) => {
  const [projectSettings, setModalProjectSettings] = useState(
    propProjectSettings
  );
  const {
    fileCabinetRatioCalculationType,
    lockerRatioCalculationType,
  } = projectSettings;
  return (
    <FileCabinetsLockersRatioDialog open={open}>
      <WorksheetUpdateDialogContent style={{ paddingBottom: '20px' }}>
        <AlignStartColumn style={{ paddingBottom: '20px' }}>
          <ScenarioNameDialogTitle style={{ paddingTop: '4px' }}>
            File Cabinets & Lockers Ratios
          </ScenarioNameDialogTitle>
          <DialogNoteBody
            style={{ color: colors.red, fontWeight: 700, paddingBottom: '8px' }}
          >
            CAUTION
          </DialogNoteBody>
          <div className="fc-locker-text-block">
            This change will apply to all worksheets in this project.
          </div>
          <div className="fc-locker-text-block">
            All worksheets use Work Seats by default to calculate Target Ratios
            per seat. An exception can be made for File Cabinets and Lockers.
          </div>
          <div className="fc-locker-text-block">
            Adjust how ratios are calculated if Headcount is the preferred
            method for calculating ratios per person instead of per seat.
          </div>
        </AlignStartColumn>
        <Grid container>
          <Grid item xs={6}>
            <AlignStartColumn
              style={{
                paddingRight: '24px',
                borderRight: '1px solid #E0E0E0',
              }}
            >
              <InputLabel style={{ fontWeight: 'bold' }}>
                FILE CABINETS
              </InputLabel>
              <FullWidthRow justifyContent="space-between" alignItems="center">
                <FormControlLabel
                  name="option-headcount-fc"
                  control={
                    <Radio
                      onClick={() =>
                        setModalProjectSettings({
                          ...projectSettings,
                          fileCabinetRatioCalculationType:
                            RatioCalculationType.HEADCOUNT,
                        })
                      }
                      checked={
                        fileCabinetRatioCalculationType ===
                        RatioCalculationType.HEADCOUNT
                      }
                    />
                  }
                  label="Headcount"
                />
                <div>{numberWithCommas(Math.round(headcount))}</div>
              </FullWidthRow>
              <FullWidthRow justifyContent="space-between" alignItems="center">
                <FormControlLabel
                  control={
                    <Radio
                      onClick={() =>
                        setModalProjectSettings({
                          ...projectSettings,
                          fileCabinetRatioCalculationType:
                            RatioCalculationType.HEADCOUNT_WITH_VACANCY,
                        })
                      }
                      checked={
                        fileCabinetRatioCalculationType ===
                        RatioCalculationType.HEADCOUNT_WITH_VACANCY
                      }
                    />
                  }
                  label="Headcount with Vacancy"
                />
                <div>{numberWithCommas(Math.round(headcountWithVacancy))}</div>
              </FullWidthRow>
              <FullWidthRow justifyContent="space-between" alignItems="center">
                <FormControlLabel
                  control={
                    <Radio
                      onClick={() =>
                        setModalProjectSettings({
                          ...projectSettings,
                          fileCabinetRatioCalculationType:
                            RatioCalculationType.HEADCOUNT_WITH_UTILIZATION,
                        })
                      }
                      checked={
                        fileCabinetRatioCalculationType ===
                        RatioCalculationType.HEADCOUNT_WITH_UTILIZATION
                      }
                    />
                  }
                  label="Headcount with Utilization"
                />
                <div>
                  {numberWithCommas(Math.round(headcountWithUtilization))}
                </div>
              </FullWidthRow>
              <FullWidthRow justifyContent="space-between" alignItems="center">
                <FormControlLabel
                  name="option-workseats-fc"
                  control={
                    <Radio
                      onClick={() =>
                        setModalProjectSettings({
                          ...projectSettings,
                          fileCabinetRatioCalculationType:
                            RatioCalculationType.WORK_SEATS,
                        })
                      }
                      checked={
                        fileCabinetRatioCalculationType ===
                        RatioCalculationType.WORK_SEATS
                      }
                    />
                  }
                  label="Work Seats"
                />
                <div>{numberWithCommas(Math.round(workSeats))}</div>
              </FullWidthRow>
            </AlignStartColumn>
          </Grid>
          <Grid item xs={6}>
            <AlignStartColumn style={{ paddingLeft: '26px' }}>
              <InputLabel style={{ fontWeight: 'bold' }}>LOCKERS</InputLabel>
              <FullWidthRow justifyContent="space-between" alignItems="center">
                <FormControlLabel
                  name="option-headcount-l"
                  control={
                    <Radio
                      onClick={() =>
                        setModalProjectSettings({
                          ...projectSettings,
                          lockerRatioCalculationType:
                            RatioCalculationType.HEADCOUNT,
                        })
                      }
                      checked={
                        lockerRatioCalculationType ===
                        RatioCalculationType.HEADCOUNT
                      }
                    />
                  }
                  label="Headcount"
                />
                <div>{numberWithCommas(Math.round(headcount))}</div>
              </FullWidthRow>
              <FullWidthRow justifyContent="space-between" alignItems="center">
                <FormControlLabel
                  control={
                    <Radio
                      onClick={() =>
                        setModalProjectSettings({
                          ...projectSettings,
                          lockerRatioCalculationType:
                            RatioCalculationType.HEADCOUNT_WITH_VACANCY,
                        })
                      }
                      checked={
                        lockerRatioCalculationType ===
                        RatioCalculationType.HEADCOUNT_WITH_VACANCY
                      }
                    />
                  }
                  label="Headcount with Vacancy"
                />
                <div>{numberWithCommas(Math.round(headcountWithVacancy))}</div>
              </FullWidthRow>
              <FullWidthRow justifyContent="space-between" alignItems="center">
                <FormControlLabel
                  control={
                    <Radio
                      onClick={() =>
                        setModalProjectSettings({
                          ...projectSettings,
                          lockerRatioCalculationType:
                            RatioCalculationType.HEADCOUNT_WITH_UTILIZATION,
                        })
                      }
                      checked={
                        lockerRatioCalculationType ===
                        RatioCalculationType.HEADCOUNT_WITH_UTILIZATION
                      }
                    />
                  }
                  label="Headcount with Utilization"
                />
                <div>
                  {numberWithCommas(Math.round(headcountWithUtilization))}
                </div>
              </FullWidthRow>
              <FullWidthRow justifyContent="space-between" alignItems="center">
                <FormControlLabel
                  control={
                    <Radio
                      name="option-workseats-l"
                      onClick={() =>
                        setModalProjectSettings({
                          ...projectSettings,
                          lockerRatioCalculationType:
                            RatioCalculationType.WORK_SEATS,
                        })
                      }
                      checked={
                        lockerRatioCalculationType ===
                        RatioCalculationType.WORK_SEATS
                      }
                    />
                  }
                  label="Work Seats"
                />
                <div>{numberWithCommas(Math.round(workSeats))}</div>
              </FullWidthRow>
            </AlignStartColumn>
          </Grid>
        </Grid>
        <AlignStartColumn style={{ marginTop: '26px' }}>
          <div className="fc-locker-text-block">
            Target Ratios will remain constant. Quantities will update on all
            worksheets in this project.
          </div>
        </AlignStartColumn>
        <JustifyStartRow style={{ marginTop: '28px' }}>
          <SPWSaveButton
            data-cy="fc-l-ratios-save"
            onClick={() => {
              setProjectSettings(projectSettings);
              onClose();
            }}
          />
          <SPWCancelButton
            onClick={() => onClose()}
            style={{ marginLeft: '16px' }}
          />
        </JustifyStartRow>
      </WorksheetUpdateDialogContent>
    </FileCabinetsLockersRatioDialog>
  );
};

export default ProgramFileCabinetsLockersRatioModal;
